import { render } from "./TablesWidget.vue?vue&type=template&id=0d1dfb7c&ts=true"
import script from "./TablesWidget.vue?vue&type=script&lang=ts"
export * from "./TablesWidget.vue?vue&type=script&lang=ts"

import "./TablesWidget.vue?vue&type=style&index=0&id=0d1dfb7c&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__